export default "version from Sat, 26 Sep 2026 09:36:13 GMT"